import {
  Apple,
  Boxes,
  Carrot,
  ChefHat,
  Drumstick,
  Flame,
  Milk,
  Package,
  Wheat,
} from "lucide-react";

const normalizeCategoryName = (namaKategori) =>
  String(namaKategori || "").trim().toLowerCase();

export const getKategoriIcon = (namaKategori) => {
  const normalized = normalizeCategoryName(namaKategori);

  if (normalized.includes("lauk")) return Drumstick;
  if (normalized.includes("sayur")) return Carrot;
  if (normalized.includes("buah")) return Apple;
  if (normalized.includes("bahan kering") || normalized.includes("kering")) return Wheat;
  if (normalized.includes("bumbu")) return ChefHat;
  if (normalized.includes("susu")) return Milk;
  if (normalized.includes("gas")) return Flame;
  if (normalized.includes("bhp")) return Boxes;

  return Package;
};

export const getKategoriTheme = (namaKategori) => {
  const normalized = normalizeCategoryName(namaKategori);

  if (normalized.includes("lauk")) {
    return {
      cardBorder: "border-rose-200",
      headerBg: "bg-rose-100/80 hover:bg-rose-200/80",
      iconText: "text-rose-700",
      titleText: "text-rose-950",
      badgeClass: "bg-rose-200/80 text-rose-800",
      tableHeadBg: "bg-rose-50/70",
      laporanRowBg: "bg-rose-100/70",
    };
  }

  if (normalized.includes("sayur")) {
    return {
      cardBorder: "border-emerald-200",
      headerBg: "bg-emerald-100/80 hover:bg-emerald-200/80",
      iconText: "text-emerald-700",
      titleText: "text-emerald-950",
      badgeClass: "bg-emerald-200/80 text-emerald-800",
      tableHeadBg: "bg-emerald-50/70",
      laporanRowBg: "bg-emerald-100/70",
    };
  }

  if (normalized.includes("buah")) {
    return {
      cardBorder: "border-amber-200",
      headerBg: "bg-amber-100/80 hover:bg-amber-200/80",
      iconText: "text-amber-700",
      titleText: "text-amber-950",
      badgeClass: "bg-amber-200/80 text-amber-800",
      tableHeadBg: "bg-amber-50/70",
      laporanRowBg: "bg-amber-100/70",
    };
  }

  if (normalized.includes("bahan kering") || normalized.includes("kering")) {
    return {
      cardBorder: "border-yellow-200",
      headerBg: "bg-yellow-100/80 hover:bg-yellow-200/80",
      iconText: "text-yellow-700",
      titleText: "text-yellow-950",
      badgeClass: "bg-yellow-200/80 text-yellow-800",
      tableHeadBg: "bg-yellow-50/70",
      laporanRowBg: "bg-yellow-100/70",
    };
  }

  if (normalized.includes("bumbu")) {
    return {
      cardBorder: "border-orange-200",
      headerBg: "bg-orange-100/80 hover:bg-orange-200/80",
      iconText: "text-orange-700",
      titleText: "text-orange-950",
      badgeClass: "bg-orange-200/80 text-orange-800",
      tableHeadBg: "bg-orange-50/70",
      laporanRowBg: "bg-orange-100/70",
    };
  }

  if (normalized.includes("susu")) {
    return {
      cardBorder: "border-sky-200",
      headerBg: "bg-sky-100/80 hover:bg-sky-200/80",
      iconText: "text-sky-700",
      titleText: "text-sky-950",
      badgeClass: "bg-sky-200/80 text-sky-800",
      tableHeadBg: "bg-sky-50/70",
      laporanRowBg: "bg-sky-100/70",
    };
  }

  if (normalized.includes("gas")) {
    return {
      cardBorder: "border-slate-300",
      headerBg: "bg-slate-200/70 hover:bg-slate-300/70",
      iconText: "text-slate-700",
      titleText: "text-slate-900",
      badgeClass: "bg-slate-300/80 text-slate-800",
      tableHeadBg: "bg-slate-100/70",
      laporanRowBg: "bg-slate-200/70",
    };
  }

  if (normalized.includes("bhp")) {
    return {
      cardBorder: "border-cyan-200",
      headerBg: "bg-cyan-100/80 hover:bg-cyan-200/80",
      iconText: "text-cyan-700",
      titleText: "text-cyan-950",
      badgeClass: "bg-cyan-200/80 text-cyan-800",
      tableHeadBg: "bg-cyan-50/70",
      laporanRowBg: "bg-cyan-100/70",
    };
  }

  return {
    cardBorder: "border-primary/20",
    headerBg: "bg-primary/10 hover:bg-primary/15",
    iconText: "text-primary",
    titleText: "text-foreground",
    badgeClass: "bg-primary/20 text-primary",
    tableHeadBg: "bg-muted/50",
    laporanRowBg: "bg-primary/10",
  };
};
